module.exports = __webpack_public_path__ + "img/logo-locker-company.69514c35.svg";